/**
 * Accepted `utm_medium` values. Anything else is dropped when reading a URL.
 *
 * Single source of truth — five hand-copied allowlists is how `sms` and `calendar`
 * came to be silently dropped (TRAV-4021). Add new mediums here only, keeping the list sorted.
 *
 * `text` is kept alongside `sms` so links already sent keep working.
 *
 * Imports nothing on purpose: `RoutesContext` and server middleware both depend on
 * this module, so it must stay a leaf to avoid a cycle.
 */
export const UTM_MEDIUMS = ['calendar', 'email', 'sms', 'text', 'web'] as const;

/** A recognised `utm_medium` value. */
export type UtmMedium = (typeof UTM_MEDIUMS)[number];

/** Whether a raw query-string value is a recognised `utm_medium`. */
export const isUtmMedium = (value?: string | null): value is UtmMedium => {
  return !!value && (UTM_MEDIUMS as ReadonlyArray<string>).includes(value);
};
